export const restrictions = {
    MAX_OU_PER_INVITE: 50,
};
